import React from 'react';
import CrudTable from '../../components/common/CrudTable';
import { trainingSchoolAPI } from '../../api/services';
import { formatCurrency } from '../../utils/formatters';

const TrainingSchoolsAdmin = () => {
  const COLUMNS = [
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
    { key: 'balance', label: 'Balance (SUM)', render: (item) => formatCurrency(item.balance) },
  ];

  const FORM_FIELDS = [
    { name: 'name', label: 'School Name', placeholder: 'Main Campus' },
    { name: 'description', label: 'Description', placeholder: 'Headquarters...', type: 'textarea' },
    { name: 'balance', label: 'Balance', placeholder: '0.00', type: 'number' },
  ];

  return (
    <CrudTable
      title="Training Schools"
      entityName="Training School"
      columns={COLUMNS}
      formFields={FORM_FIELDS}
      fetchData={async () => {
        const res = await trainingSchoolAPI.getAll();
        return res.data?.data || [];
      }}
      onAdd={(data) => trainingSchoolAPI.add(data)}
      onUpdate={(id, data) => trainingSchoolAPI.update(id, data)}
      onDelete={(id) => trainingSchoolAPI.delete(id)}
    />
  );
};

export default TrainingSchoolsAdmin;
